import styled from '@emotion/styled';
import { normalizeImgSource } from '@innovamat/ga-features';
import { ImageComponent } from '@innovamat/glimmer-components';
import type { ReactNode } from 'react';
import { StyledBody } from './styled-text';

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
`;

const Image = styled(ImageComponent)`
  width: 166px;
  height: 120px;
  aspect-ratio: 83/60;
  flex-shrink: 0;
`;

type ContentWithImageProps = {
  children: ReactNode;
  imageSrc: string;
  imageAlt: string;
};

export const ContentWithImage = ({
  children,
  imageSrc,
  imageAlt,
}: ContentWithImageProps): JSX.Element => {
  return (
    <ContentContainer>
      <TextContent>
        <StyledBody>{children}</StyledBody>
      </TextContent>
      <Image src={normalizeImgSource(imageSrc)} alt={imageAlt} />
    </ContentContainer>
  );
};
